import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import styled from 'styled-components';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container } from '@material-ui/core';
import NumberFormat from 'react-number-format';



const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#009691",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledCostCell = withStyles(theme => ({
  head: {
    backgroundColor: "red",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const ResponsiveContainer = styled(Container)`
  margin: 12px;
  padding: 0px !important;
`

const ProfitRow = styled(TableRow)`
  background-color: #17B054;
  td {
    color: white;
    font-weight: 500;
  }
`

const CostsRow = styled(TableRow)`
background-color: #F01205;
td {
  color: white;
  font-weight: 500;
}
`

const CostsSubItem = styled(TableRow)`
background-color: #F01205;
td {
  color: white;
}
`

const RevenueRow = styled(TableRow)`
background-color: #009691;
td {
  color: white;
  font-weight: 500;
}
`

function ResultChart(props) {
  const MC = props.financialSetup.revenue * (props.financialSetup.merchandiseCost / 100)
  return (
    <ResponsiveContainer>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableBody>
            <RevenueRow>
              <StyledTableCell>Faturamento estimado</StyledTableCell>
              <StyledTableCell colSpan={2} align="right"><NumberFormat decimalScale={2} fixedDecimalScale={true} value={props.financialSetup.revenue} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} prefix={'R$'} /></StyledTableCell>
            </RevenueRow>
            <CostsRow>
              <StyledCostCell>Gastos</StyledCostCell>
              <StyledCostCell colSpan={2} align="right"><NumberFormat decimalScale={2} fixedDecimalScale={true} value={props.variableCosts + props.fixedCosts + MC} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} prefix={'R$'} /></StyledCostCell>
            </CostsRow>
            <CostsSubItem>
              <StyledTableCell>- Despesas sobre vendas</StyledTableCell>
              <StyledTableCell colSpan={2} align="right"><NumberFormat decimalScale={2} fixedDecimalScale={true} value={props.variableCosts} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} prefix={'R$'} /></StyledTableCell>
            </CostsSubItem>
            <CostsSubItem>
              <StyledTableCell>- Custos fixos</StyledTableCell>
              <StyledTableCell colSpan={2} align="right"><NumberFormat decimalScale={2} fixedDecimalScale={true} value={props.fixedCosts} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} prefix={'R$'} /></StyledTableCell>
            </CostsSubItem>
            <CostsSubItem>
              <StyledTableCell>- Custo de mercadoria</StyledTableCell>
              <StyledTableCell colSpan={2} align="right"><NumberFormat decimalScale={2} fixedDecimalScale={true} value={MC} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} prefix={'R$'} /></StyledTableCell>
            </CostsSubItem>
            <ProfitRow>
              <StyledTableCell>Lucro operacional</StyledTableCell>
              <StyledTableCell colSpan={2} align="right"><NumberFormat decimalScale={2} fixedDecimalScale={true} value={(props.financialSetup.revenue - props.variableCosts - props.fixedCosts - MC)} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} prefix={'R$'} /></StyledTableCell>
            </ProfitRow>
          </TableBody>
        </Table>
      </TableContainer>
    </ResponsiveContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    activeTab: state.reducers.activeTab,
    financialSetup: state.reducers.financialSetup
  }
}

export default connect(
  mapStateToProps,
  null
)(ResultChart)
